import { tsRestClient } from "@api/tsRest";

import { userState } from "@store/userStore";

import C from "../../constants/constants";

interface IAnalytics {
  [key: string]: (...arguments_: unknown[]) => void;
  identify: (...arguments_: unknown[]) => void;
  page: (...arguments_: unknown[]) => void;
  track: (...arguments_: unknown[]) => void;
}

declare global {
  interface Window {
    analytics: IAnalytics;
  }
}

const isProductionEnvironment = C.ENVIRONMENT === "production" || C.ENVIRONMENT === "staging";

/**
 * Tracks an event using the specified event name and properties.
 * @param eventName - The name of the event to track.
 * @param properties - Additional properties associated with the event.
 */
const trackEvent = (eventName: string, properties: Record<string, unknown> = {}) => {
  const { organizationId } = userState();

  const eventProperties: Record<string, unknown> = {
    ...properties,
    ...(organizationId && { organization_id: organizationId }),
  };

  if (isProductionEnvironment) {
    tsRestClient.analytics
      .trackEvent({
        body: {
          event: eventName,
          properties: eventProperties,
        },
      })
      .catch((error) => {
        console.error("Error on event:", error);
      });
  }
};

export default trackEvent;
